import React from 'react';
import { motion } from 'framer-motion';

const SkeletonTableLoader = ({ numRows = 5, numCols = 5 }) => {
  return (
    <tbody className="divide-y divide-border">
      {Array(numRows)
        .fill('')
        .map((_, rowIndex) => (
          <motion.tr
            key={rowIndex}
            className="animate-pulse"
            initial={{ opacity: 0.5 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, yoyo: Infinity }}
          >
            {Array(numCols)
              .fill('')
              .map((_, colIndex) => (
                <td key={colIndex} className="px-3 py-3">
                  <div className="h-4 rounded-md bg-muted"></div>
                </td>
              ))}
          </motion.tr>
        ))}
    </tbody>
  );
};

export default SkeletonTableLoader;
